import { Box, Typography } from '@mui/material';

export const STPDescription = ({ mt }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between', position: 'relative', mt: mt }}>
      <Typography variant="h7" sx={{ color: 'black', textAlign: 'center' }}>
        93 64 739 40
      </Typography>
      <Typography variant="h7" sx={{ color: 'black', textAlign: 'center' }}>
        training@vilatraining.cat
      </Typography>
      <Typography variant="h7" sx={{ color: 'black', textAlign: 'center' }}>
        Avinguda de Can Batllori, 24
      </Typography>
      <Typography variant="h7" sx={{ color: 'black', textAlign: 'center' }}>
        08840 - Viladecans
      </Typography>
      <Typography variant="h7" sx={{ color: 'black', textAlign: 'center' }}>
        Barcelona
      </Typography>
    </Box>
  )
}